import { ERP } from '../_base/endpoint';
import axios from 'axios';

import global from '../../common/utility/global';

class cuentasCobrarService {

    /******* QUERIES ******/

    async paginacion(filter) {
        const response = await axios
            .get(`${ERP}tesoreria/cobranza/paginacion?${global.formatParameter(filter)}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async cobranza_credito(filter) {
        const response = await axios
            .get(`${ERP}tesoreria/cobranza/cobranza-credito?${global.formatParameter(filter)}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async documentos_cancelados(filter) {
        const response = await axios
            .get(`${ERP}tesoreria/cobranza/documentos-cancelados?${global.formatParameter(filter)}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };


    async cobranza_clientes(filter) {
        const response = await axios
            .get(`${ERP}tesoreria/cobranza/cobranza_clientes?${global.formatParameter(filter)}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async obtenerDocumentoNroSerie(IdCliente) {
        const response = await axios
            .get(`${ERP}tesoreria/cobranza/comprobante/${IdCliente}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };


    async verPlanillaResumen(filter) {
        const response = await axios
            .get(`${ERP}tesoreria/cobranza/planillaResumen?${global.formatParameter(filter)}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async verPlanillaDetallado(filter) {
        const response = await axios
            .get(`${ERP}tesoreria/cobranza/planillaDetallado?${global.formatParameter(filter)}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };


    /*****REPORTES */

    async excelPlanillaResumen(filter) {
        const response = await axios
            .get(`${ERP}tesoreria/cobranza/excelResumen?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };


    async excelPlanillaDetallado(filter) {
        const response = await axios
            .get(`${ERP}tesoreria/cobranza/excelDetallado?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async excelPlanilla(filter) {
        const response = await axios
            .get(`${ERP}tesoreria/cobranza/excelPlanilla?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async excel(filter) {
        const response = await axios
            .get(`${ERP}tesoreria/cobranza/excel?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async pdf(filter) {
        const response = await axios
            .get(`${ERP}tesoreria/cobranza/pdf?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async pdfA4(filter) {
        const response = await axios
            .get(`${ERP}tesoreria/cobranza/pdf-a4?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async ticket(filter) {
        const response = await axios
            .get(`${ERP}tesoreria/cobranza/pdf-ticket?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    /******* TRANSACCIONES ******/

    async registrar(data) {
        const response = await axios
            .post(`${ERP}tesoreria/cuentas-cobrar`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };
    async anular(data) {
        const response = await axios
            .put(`${ERP}tesoreria/cobranza/anular`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };



}

export default new cuentasCobrarService();